import React from "react";
import { NavLink } from "react-router-dom";
import { Breadcrumb as BreadcrumbSemantic } from "semantic-ui-react";

import styled from "styled-components";

const BreadCrumbWrapper = styled.div`
  .ui.breadcrumb .active.section {
    font-weight: 400;
  }
`;

type BreadCrumbItem = {
  content: string;
  link: boolean;
  to?: string;
};

interface IBreadCrumbProps {
  items: BreadCrumbItem[];
}

const NavBar = (props: any) => {
  const content: any = [];
  props.nav.forEach((item: any, i: number) => {
    let bread: any;
    if (item.link) {
      bread = (
        <BreadcrumbSemantic.Section key={`item__${i}`} as={NavLink} to={item.to}>
          {item.content}{" "}
          {i + 1 !== props.nav.length && <BreadcrumbSemantic.Divider icon="right chevron" />}
        </BreadcrumbSemantic.Section>
      );
    } else {
      bread = (
        <BreadcrumbSemantic.Section key={`item__${i}`}>
          {item.content}{" "}
          {i + 1 !== props.nav.length && <BreadcrumbSemantic.Divider icon="right chevron" />}
        </BreadcrumbSemantic.Section>
      );
    }

    content.push(bread);
  });

  return (
    <BreadCrumbWrapper>
      <BreadcrumbSemantic>{content}</BreadcrumbSemantic>
    </BreadCrumbWrapper>
  );
};

const BreadCrumb: React.FC<IBreadCrumbProps> = (props: IBreadCrumbProps) => {
  const items: BreadCrumbItem[] = props.items;
  return (
    <div style={{ marginBottom: "1rem" }}>
      <NavBar nav={items} />
    </div>
  );
};

export default BreadCrumb;
